import BaseService from './base/base.service'

export default class MembersAreaService extends BaseService {

    constructor(){
        super('members')
    }

}